import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './baseQuery';

export interface IDaily {
  daily_summaries_id: number;
  daily_summaries_get_datetime: string;
  daily_summaries_total_point_amount: number;
  daily_summaries_used_point_amount: number;
  daily_summaries_expired_point_amount: number;
  daily_summaries_point_get_num: number;
  daily_summaries_any_point_amount: number;
  daily_summaries_form_point_amount: number;
  daily_summaries_gacha_point_amount: number;
  daily_summaries_invaited_point_amount: number;
}

// Define a service using a base URL and expected endpoints
export const dailySummariesApi = createApi({
  reducerPath: 'daily',
  tagTypes: ['daily_summaries'],
  baseQuery: axiosBaseQuery(),
  endpoints: builder => ({
    getAllDailySummaries: builder.query<IDaily[], string>({
      query: params => ({
        url: `/daily_summaries${params && '?' + params}`,
        method: 'GET',
      }),
      providesTags: ['daily_summaries'],
      transformResponse: (response: { data_response: IDaily[] }, meta, arg) =>
        response.data_response,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAllDailySummariesQuery } = dailySummariesApi;
